module.exports = __webpack_public_path__ + "static/media/home-workout-bg.4a6c72c1.png";